import { HeartHandshake, ShieldCheck, Users } from "lucide-react";
import Reveal from "./Reveal";

const IMG_HANDS =
    "https://images.unsplash.com/photo-1580869318757-a6c605b061ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxoZWxwaW5nJTIwaGFuZHMlMjBlbGRlcmx5JTIwY2FyZSUyMGZyaWVuZHNoaXB8ZW58MHx8fHwxNzkyNDI5MTI1fDA&ixlib=rb-4.1.0&q=85";

const VALUES = [
    {
        icon: HeartHandshake,
        title: "Prima la persona",
        desc: "Non siamo un servizio anonimo: conosciamo chi assistiamo, ricordiamo i dettagli e trattiamo ogni persona come un amico.",
    },
    {
        icon: ShieldCheck,
        title: "Fiducia e affidabilità",
        desc: "Orari chiari, presenza puntuale e contatto diretto: un solo numero, una sola persona di riferimento.",
    },
    {
        icon: Users,
        title: "Per tutte le età",
        desc: "Dai giovani agli anziani: chi ha bisogno di una mano per le cose di tutti i giorni la trova qui, senza giudizio.",
    },
];

export const WhyUs = () => (
    <section id="perche-noi" className="py-24 lg:py-32 bg-stonewarm/60 border-y border-line/60">
        <div className="mx-auto max-w-7xl px-5 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center">
            <div className="lg:col-span-6 order-2 lg:order-1">
                <Reveal>
                    <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-terracotta">
                        Perché ServiziAmici
                    </p>
                    <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink">
                        L'aiuto di tutti i giorni,
                        <br />
                        <em className="italic text-terracotta">
                            con l'anima di un amico.
                        </em>
                    </h2>
                    <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-mutedwarm">
                        ServiziAmici nasce con un'idea semplice: il supporto
                        quotidiano funziona meglio quando sembra la compagnia di
                        un amico. Lavoriamo in Emilia-Romagna, con assistenza
                        non medica e supporto attivo su misura per ogni persona.
                    </p>
                </Reveal>

                <div className="mt-12 space-y-8">
                    {VALUES.map((v, i) => (
                        <Reveal key={v.title} delay={0.1 * i}>
                            <div
                                data-testid={`whyus-value-${i}`}
                                className="group flex items-start gap-5"
                            >
                                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-terracotta/10 text-terracotta transition-colors duration-300 group-hover:bg-terracotta group-hover:text-cream">
                                    <v.icon className="h-5 w-5" />
                                </span>
                                <div>
                                    <h3 className="font-serif text-xl sm:text-2xl text-ink">
                                        {v.title}
                                    </h3>
                                    <p className="mt-1.5 text-sm sm:text-base leading-relaxed text-mutedwarm">
                                        {v.desc}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>

            <div className="lg:col-span-6 order-1 lg:order-2">
                <Reveal y={40} className="relative max-w-[520px] mx-auto lg:ml-auto">
                    <div className="arch-frame relative">
                        <img
                            src={IMG_HANDS}
                            alt="Tre paia di mani si tengono insieme, gesto di supporto"
                            loading="lazy"
                            className="h-[420px] sm:h-[520px] w-full object-cover"
                        />
                        <div aria-hidden="true" className="absolute inset-0 bg-ink/5" />
                    </div>
                    <div className="absolute -bottom-6 right-5 sm:right-8 rounded-2xl bg-ink text-cream px-6 py-5 shadow-xl shadow-ink/20">
                        <p className="font-serif text-lg italic leading-snug">
                            "Ti trattiamo come
                            <br />
                            tratteremmo un amico."
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default WhyUs;
